import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Pythontemplate from "../../component/course/python";

export default class Pythoninameerpet extends Component {
 
  render() {
   
    const title = "Python"
    const url= "python"
    const url1 ="-training-in-ameerpet"
    const location = "ameerpet" 
    const location1="Training in Ameerpet"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Upgrade your skills with the best Python ${location1}. Learn from experienced instructors, get certified and start your journey to becoming a Python expert. Join our classes today!`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Pythontemplate url1={url1} url={url} title={title} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
